import { useUpdateChat } from '@services/chat/mutations/useUpdateChat'
import { RotateCcw } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import type { ChatDetail } from 'types/api'

import { Button } from '@/components/ui/button'
import { useConfirm } from '@/components/ui/confirm-dialog'

import { ChatEmptyDescription } from '../ChatEmptyDescription'

export function ChatInactiveFooter({ chat }: { chat: ChatDetail }) {
  const updateChat = useUpdateChat()
  const { confirm, dialog } = useConfirm()
  const { t } = useTranslation('chat')

  const handleReactivateChat = async () => {
    if (
      (await confirm({ title: t('form.common.reactivate_confirm') })) &&
      chat?.id
    ) {
      updateChat.mutate({
        id: chat.id,
        body: { title: chat.title, offer: chat.offer, is_active: true }
      })
    }
  }

  return (
    <div className="flex flex-col items-center gap-3 py-2">
      <ChatEmptyDescription text={t('form.common.ended_chat')} />
      <Button variant="ghostDark" onClick={handleReactivateChat}>
        <RotateCcw className="h-4 w-4" />
        {t('form.common.update_chat')}
      </Button>
      {dialog}
    </div>
  )
}
